const MODAL_STATE_FLAG_PREFIX = 'is';
const MODAL_STATE_FLAG_SUFFIX = 'Open';

const MODAL_IDS = {
  ADD_TO_CART_MODAL: 'AddToCartModal',
  PRODUCT_SORT_TYPE_SELECTOR_MODAL: 'ProductSortTypeSelectorModal',
  SUCCESSFUL_ADD_TO_CART_FEEDBACK_DIALOG: 'SuccessfulAddToCartFeedbackDialog',
  OTHER_MERCHANTS_MODAL: 'OtherMerchantsModal',
  TRUST_LABEL_MODAL: 'TrustLabelModal',
  TABS_MODAL: 'TabsModal',
  SIZE_CHART: 'SizeChart',
  ENERGY_CLASS: 'EnergyClass',
  CAMPAIGN: 'Campaign',
  ERROR_POPUP: 'ErrorPopup',
  PREMIUM_CONTENT: 'PremiumContent'
};

export {
  MODAL_IDS,
  MODAL_STATE_FLAG_PREFIX,
  MODAL_STATE_FLAG_SUFFIX
}
